"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseService = void 0;
const tslib_1 = require("tslib");
const client_1 = require("./client/client");
class BaseService {
    constructor(path, authorization, baseUrl, logger) {
        const url = baseUrl.replace(/\/$/, '') + path;
        this.client = (0, client_1.createClient)(url, {
            headers: {
                Authorization: authorization,
            },
            logger,
        });
    }
    requestRecursively(query, getter, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const request = (cursor) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const response = yield this.client.request(query, Object.assign(Object.assign({}, params), { cursor }));
                const { cursor: nextCursor, items } = getter(response);
                if (nextCursor) {
                    return [...items, ...(yield request(nextCursor))];
                }
                return items;
            });
            return request();
        });
    }
}
exports.BaseService = BaseService;
//# sourceMappingURL=base-service.js.map